/** Minutes after scheduled start before clock-in counts as late (no clock-in or clock-in time). */
export const LIVE_VIEW_CLOCK_IN_GRACE_MINUTES = 5;
